import classNames from 'classnames';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslations } from 'next-intl';

type Props = {
  placeholder?: string;
};

const TitleField = ({ placeholder }: Props) => {
  const t = useTranslations();
  const { control } = useFormContext();

  return (
    <div className={styles.title.container}>
      <Controller
        control={control}
        name="title"
        render={({ field: { onChange, value, onBlur } }) => (
          <input
            id={'title'}
            autoComplete="off"
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            className={styles.title.input}
            placeholder={placeholder ?? t('memoComposer.title')}
          />
        )}
        rules={{
          required: {
            value: true,
            message: t('memoComposer.titleRequired'),
          },
        }}
      />
    </div>
  );
};

export default TitleField;

const styles = {
  title: {
    container: 'border-none outline-hidden',
    input: classNames(
      'w-full bg-transparent font-bold text-base text-ink-primary px-0 border-none outline-hidden focus:outline-hidden',
      'focus:border-transparent focus:ring-0 caret-blue-600',
    ),
  },
};
